import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFlightSearchStore } from '../store/flightSearch/flightSearchStore';
import AuthenticatedRoute from './AuthenticatedRoute';

type Props = {
  children: ReactNode
}
function FlightDataFilled({ children }: Props) {
  const navigate = useNavigate();
  const {
    formData: { OriginLocationCode, multiCity },
  } = useFlightSearchStore();

  const firstOriginLocationCodeInMultiCity = multiCity && multiCity?.length > 0 && multiCity[0]?.OriginLocationCode;
  useEffect(() => {
    if (!OriginLocationCode && !firstOriginLocationCodeInMultiCity) {
      navigate('/search/flight');
    }
  }, [OriginLocationCode, firstOriginLocationCodeInMultiCity, navigate]);
  return (
    <AuthenticatedRoute>
      {children}
    </AuthenticatedRoute>
  );
}

export default FlightDataFilled;
